export default __webpack_public_path__ + "static/media/english-to-finnish-screenshot-06.956ff1f6.png";